'use client';

import useUser from '@alltrails/context/hooks/useUser';
import useTinuitiPixel from '@alltrails/core/hooks/marketingTracking/useTinuitiPixel';
import GoogleOneTap from '@alltrails/layout/components/GoogleOneTap';
import useBraze from '@alltrails/layout/hooks/useBraze';
import useOsano from '@alltrails/layout/hooks/useOsano';
import AmplitudeBrowserSdk from '@alltrails/layout/scripts/AmplitudeBrowserSdk';
import Sprig from '@alltrails/layout/scripts/Sprig';
import ReturningUserUpsell from '@alltrails/upsell/components/ReturningUserUpsell/ReturningUserUpsell';
import UpsellContentLoader from '@alltrails/upsell/components/UpsellContentLoader/UpsellContentLoader';
import useAppleRedirectHandler from '@alltrails/user-auth/hooks/useAppleRedirectHandler';
import { useAppSelector } from '@/utils/redux';

const TrailPageAnalytics = () => {
  useOsano();
  useTinuitiPixel();
  useBraze();
  useAppleRedirectHandler();

  const limitReached = useAppSelector(state => state.trailPage.viewLimitReached);
  const user = useUser();

  return (
    <>
      <AmplitudeBrowserSdk logDwellTime />
      <Sprig userId={user?.id} />
      <UpsellContentLoader />
      {limitReached !== 'uninitialized' && <GoogleOneTap pageViewLimitReached={limitReached} />}
      <ReturningUserUpsell />
    </>
  );
};

export default TrailPageAnalytics;
